export default "__VITE_ASSET__0iEN0TKN__"